/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FunnelDiscountDto
 */
export interface FunnelDiscountDto {
    /**
     * 
     * @type {number}
     * @memberof FunnelDiscountDto
     */
    discountPrice: number;
    /**
     * 
     * @type {number}
     * @memberof FunnelDiscountDto
     */
    discountPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof FunnelDiscountDto
     */
    initialPrice: number;
    /**
     * 
     * @type {number}
     * @memberof FunnelDiscountDto
     */
    newPrice: number;
}

/**
 * Check if a given object implements the FunnelDiscountDto interface.
 */
export function instanceOfFunnelDiscountDto(value: object): value is FunnelDiscountDto {
    if (!('discountPrice' in value) || value['discountPrice'] === undefined) return false;
    if (!('discountPercentage' in value) || value['discountPercentage'] === undefined) return false;
    if (!('initialPrice' in value) || value['initialPrice'] === undefined) return false;
    if (!('newPrice' in value) || value['newPrice'] === undefined) return false;
    return true;
}

export function FunnelDiscountDtoFromJSON(json: any): FunnelDiscountDto {
    return FunnelDiscountDtoFromJSONTyped(json, false);
}

export function FunnelDiscountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FunnelDiscountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'discountPrice': json['discountPrice'],
        'discountPercentage': json['discountPercentage'],
        'initialPrice': json['initialPrice'],
        'newPrice': json['newPrice'],
    };
}

export function FunnelDiscountDtoToJSON(json: any): FunnelDiscountDto {
    return FunnelDiscountDtoToJSONTyped(json, false);
}

export function FunnelDiscountDtoToJSONTyped(value?: FunnelDiscountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'discountPrice': value['discountPrice'],
        'discountPercentage': value['discountPercentage'],
        'initialPrice': value['initialPrice'],
        'newPrice': value['newPrice'],
    };
}

